<div class="content-wrapper" style="min-height: 307px">
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" type="triangle-skew-spin" [fullScreen]="false">
        <p style="color: white"> Loading... </p>
    </ngx-spinner>
    <div class="container-fluid">
        <div class="card">
            <div class="card-header bg-primary">โหลดข้อมูล KML แปลงอ้อยปี {{year_S.yearDesc}}</div>
            {{year_S|json}}
            <div class="row">
                <div class="col">
                    <mat-form-field class="example-full-width" appearance="fill">
                        <mat-label>กรุณาเลือกปี</mat-label>
                        <mat-select disableRipple required [(ngModel)]="year_S">
                            <mat-option [value]="" disabled>-- เลือกปี --</mat-option>
                            <mat-option *ngFor="let item of year_L" [value]=item>{{item.yearDesc}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col">
                    <section>
                        <div class="example-label">DATA_firebase</div>
                        <div class="example-button-row">
                            <button mat-raised-button color="accent" (click)="getMapall()">DATA_firebase</button>
                        </div>
                        <div class="example-label">maps length : {{maps.length|number}}</div>
                        <div class="example-button-row">
                            <button mat-raised-button color="warn" (click)="generateJsonFiles()"
                                *ngIf="maps.length>0">all
                                load_Data.json</button>
                        </div>
                    </section>
                </div>
                <div class="col">
                    <div class="example-label">DATA_from_file.json</div>
                    <div class="example-button-row">
                        <input type="file" accept=".json" (change)="openJSONFile($event)">
                    </div>
                    <div *ngIf="zone.length > 0">
                        <mat-form-field appearance="fill">
                            <mat-label>เลือกโซน</mat-label>
                            <mat-select disableRipple required [(ngModel)]="szone" (ngModelChange)="filter_data()">
                                <mat-option value="all"> ทุกโซน </mat-option>
                                <mat-option *ngFor="let item of zone" [value]="item">
                                    {{item}}
                                </mat-option>
                                <mat-option value="all"> ทุกโซน </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <div class="example-label">length : {{maps_s.length|number}}</div>
                        <div class="example-button-row">
                            <button mat-raised-button color="primary" (click)="generateKMLFiles()"
                                *ngIf="maps_s.length>0">{{szone}} load_Data.kml</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--<div class="row">
            <div *ngIf="maps.length>0">
                <h2>JSON Data</h2>
                <pre>{{ maps | json }}</pre>
            </div>
        </div>-->
    </div>
    <div class="card">
        <input type="file" (change)="handleFileUpload($event)" accept=".json" />
        <button (click)="generateKML2()" [disabled]="jsonData.length==0">Download KML</button>

    </div>
</div>